import { Link } from "react-router-dom";
const mudraHighlights = [
  {
    title: "Zimmer, in denen Sie mit dem Meer eins werden",
    image: "/images/Mudra Edited/DSC02142.webp",
    paragraphs: [
      "Im dreist\xF6ckigen Geb\xE4ude direkt am wundersch\xF6nen Strand gibt es nur 11 private R\xE4ume. Ideal f\xFCr alle, die bewusst mit der Zeit umgehen m\xF6chten \u2013 ein ruhiges Zuhause am Meer. Alle Zimmer liegen direkt am Meer, und von Ihrem eigenen Balkon aus erleben Sie den Atem der Wellen ganz nah.",
      "Die gro\xDFz\xFCgigen Innenr\xE4ume von etwa 34 m\xB2 sind mit allem ausgestattet, was f\xFCr einen angenehmen Aufenthalt wichtig ist. Von der Dachterrasse im dritten Stock aus genie\xDFen Sie atemberaubende Panoramablicke auf den Indischen Ozean."
    ],
    features: [
      "Zimmerausstattung: Deckenventilator, Klimaanlage und Moskitonetz inklusive.",
      "Sicherheits- und Komfortfeatures: eigenes Badezimmer, F\xF6hn, Safe, Telefon und kostenloses WLAN.",
      "Design-Lounge, kleine Bibliothek und ein Garten, durch den die Meeresbrise zieht."
    ]
  },
  {
    title: "Ein warmes Restaurant mit k\xF6stlichen Genussmomenten",
    image: "/images/Mudra Edited/DSC02270.webp",
    paragraphs: [
      "Im Restaurant mit gem\xFCtlicher Atmosph\xE4re genie\xDFen Sie t\xE4glich frisch zubereitete ayurvedische Speisen aus hochwertigen Zutaten, individuell auf Ihren K\xF6rperbau und Ihre Konstitution abgestimmt.",
      "Genie\xDFen Sie in ruhiger Atmosph\xE4re ein reichhaltiges Geschmackserlebnis, das alle Sinne erf\xFCllt."
    ],
    link: { label: "Mehr \xFCber die ayurvedische K\xFCche erfahren", href: "/ayurveda/food" }
  },
  {
    title: "Herzliche Pflege durch Ayurveda-\xC4rzte und Therapeuten",
    image: "/images/Mudra Edited/DSC01938.webp",
    paragraphs: [
      "Im Ayurveda-Zentrum von Hiru Mudra betreuen qualifizierte und erfahrene \xC4rzte Sie mit gr\xF6\xDFter Aufmerksamkeit und Sorgfalt. Die t\xE4glichen Behandlungen des professionellen Therapie-Teams f\xFChren K\xF6rper und Geist in tiefe Entspannung.",
      "Bei gutem Wetter empfehlen wir Fu\xDFmassagen, Gesichtsbehandlungen und \u2013 als Highlight Ihres Aufenthalts \u2013 Blumenb\xE4der im wundersch\xF6nen Garten. Umgeben von tropischen Blumen und einer warmen Brise k\xF6nnen Sie in v\xF6lliger Harmonie mit der Natur entspannen."
    ],
    link: { label: "Mehr zu den verschiedenen Behandlungen", href: "/ayurveda/panchakarma" }
  },
  {
    title: "Neue Eindr\xFCcke in Induruwa",
    image: "/images/Mudra Edited/DSC02312.webp",
    paragraphs: [
      "Zwischen intensiven Behandlungen haben Sie Zeit, sich au\xDFerhalb des Resorts zu erfrischen. Erkunden Sie die nahegelegene Stadt Beruwala oder fahren Sie etwas weiter zu der UNESCO-Stadt Galle, um die Geschichte der Altstadt zu entdecken. Bootstouren und Inselrundfahrten bieten ebenfalls eine entspannende und erlebnisreiche Abwechslung.",
      "Wir helfen Ihnen gern bei der Planung kleiner Ausfl\xFCge, damit Ihr Aufenthalt noch reicher und angenehmer wird."
    ]
  }
];
const AboutMudra = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Hiru Mudra / Induruwa
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Ein ruhiger Strand-Resort, erfüllt von Freude und Harmonie
                    </h2>
                    <div className="mx-auto mt-8 flex h-28 w-64 items-center justify-center sm:h-36 sm:w-80">
                        <img
    src="/images/Logos/hiru_mudra.webp"
    alt="Logo des Ayurveda-Resorts Hiru Mudra"
    width={320}
    height={144}
    className="h-full w-full object-contain" loading="lazy" />
                    </div>
                    <div className="mx-auto mt-8 max-w-3xl space-y-5 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        <p>
                            Der Name „Hiru Mudra“ entstand im August 2017 und leitet sich von dem Handzeichen „Mudra“ ab, das in Yoga und spirituellen Ritualen eine wichtige Rolle spielt. Der Name bedeutet auf Sanskrit „das, was Freude bringt“ – und genau das ist die Idee dieses Ortes: die kleinen Freuden des Alltags wiederzuentdecken.
                        </p>
                        <p>
                            Das Resort liegt in der kleinen Stadt Induruwa südlich von Bentota. Der Ort ist noch weitgehend unberührt und bietet endlose ruhige Strände, an denen Sie langsam entlanggehen und die Last des Alltags hinter sich lassen können. Hier wartet ein entspannter, ruhiger Moment auf Sie.
                        </p>
                    </div>
                </div>

                <div className="mx-auto mt-14 grid max-w-7xl gap-7 md:grid-cols-2 lg:mt-20 lg:gap-9">
                    {mudraHighlights.map((highlight) => <article key={highlight.title} className="overflow-hidden rounded-[24px] bg-[#fbfaf7] shadow-[0_20px_60px_rgba(16,38,26,0.08)]">
                            <div className="relative h-72 bg-[#f3eee7] sm:h-80">
                                <img src={highlight.image} alt={highlight.title} className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/75 via-transparent to-transparent" />
                                <h3 className="absolute inset-x-5 bottom-5 font-serif text-2xl font-semibold leading-tight text-white sm:text-3xl">{highlight.title}</h3>
                            </div>
                            <div className="p-6 sm:p-7">
                                <div className="space-y-4 font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                                    {highlight.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                                </div>
                                {highlight.features ? <ul className="mt-5 space-y-3 border-l-2 border-amber-300 pl-4 font-mulish text-sm leading-7 text-[#475569] sm:text-base">
                                        {highlight.features.map((feature) => <li key={feature}>{feature}</li>)}
                                    </ul> : null}
                                {highlight.link ? <Link to={highlight.link.href} className="mt-6 inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]">
                                        » {highlight.link.label}
                                    </Link> : null}
                            </div>
                        </article>)}
                </div>
            </div>
        </section>;
};
export default AboutMudra;
